export default {
  LOGGED_IN: 'Login',
  USER_LOADED: 'User Loaded',
  LOGGED_OUT: 'Logout',
  SHIPMENT_SEARCHED: 'Searched Shipments',
  SHIPMENT_CREATED: 'Shipment Created',
  SHIPMENT_EDITED: 'Shipment Edited',
  SHIPMENT_DELETED: 'Shipment Deleted',
  SHIPMENT_ENDED: 'Shipment Ended',
  SHIPMENTS_BULK_ARCHIVED: 'Bulk Archive Shipments',
  SHIPMENTS_BULK_UNARCHIVED: 'Bulk Unarchive Shipments',
  SHIPMENTS_BULK_DELETED: 'Bulk Delete Shipments',
  SHIPMENT_LIST_VIEWED: 'Shipment List Viewed',
  SHIPMENT_ARCHIVED_LIST_VIEWED: 'Shipment Archived List Viewed',
  SHIPMENT_VIEWED: 'Shipment Viewed',
  RULE_CREATED: 'Rule Created',
  TRACKERS_SEARCHED: 'Searched Trackers',
  TRACKERS_FILTERED: 'Filtered Trackers',
  TRACKER_MAP_VIEW_CHANGED: 'Change Tracker Map View',
  GROUPS_SEARCHED: 'Searched Groups',
  ALL_TRACKERS_VIEWED: 'Tracker List Viewed',
  TRACKER_NAME_EDITED: 'Tracker Name Edited',
  TRACKER_NAME_EDIT_CANCELLED: 'Edit Tracker Name Cancelled',
  COMMAND_SENT_TO_TRACKER: 'Command Sent to Tracker',
  COMMAND_EXECUTED: 'Command Executed',
  TRACKER_VIEWED: 'Tracker Viewed',
  ALL_GROUPS_VIEWED: 'Groups List Viewed',
  GROUP_CREATED: 'Created Group',
  GROUP_VIEWED: 'Group Viewd',
  DEVICES_ADDED_TO_GROUP: 'Added Devices to Group',
  GROUP_DEVICES_SWAPPED: 'Swapped Group Devices',
  GROUP_DEVICES_REMOVED: 'Removed Devices From Group',
  GROUP_EDITED: 'Updated Group',
  GROUP_DELETED: 'Deleted Group',
  GEOFENCE_SEARCHED: 'Searched Geofences',
  GEOFENCE_CREATED: 'Geofence Created',
  GEOFENCE_LIST_VIEWED: 'Geofence List Viewed',
  GEOFENCE_VIEWED: 'Geofence Viewed',
  GEOFENCE_DELETED: 'Geofence Deleted',
  GET_HELP_CLICKED: 'Get Help Clicked',
  PAGE_VIEWED: 'Page Viewed',
  CURRENT_ACCOUNT_CHANGED: 'Selected Account',

  ALL_BLE_ANCHORS_VIEWED: 'BLE Anchors List Viewed',
  BLE_ANCHOUR_CREATED: 'Created BLE Anchor',
  BLE_ANCHOUR_EDITED: 'Edited BLE Anchor',
  BLE_ANCHOUR_DELETED: 'Deleted BLE Anchor',

  REPORT_CREATED: 'Created Report',
  REPORT_VIEWED: 'Viewed Report',
  REPORT_EDITED: 'Edited Report',
  REPORT_DELETED: 'Deleted Report',

  RULE_EDITED: 'Edited Rule',
  RULE_DELETED: 'Deleted Rule',

  USER_INVITED: 'Invited User',
  USER_REMOVED: 'Removed User From Account',
  USER_EDITED: 'Updated User Permissions',

  ADDRESS_CREATED: 'Created Address',
  ADDRESS_SET_AS_DEFAULT: 'Set Address As Default',
  ADDRESS_DELETED: 'Deleted Address',

  PAYMENT_METHOD_CREATION_INITIATED: 'Initiated Creating Payment Method',
  PAYMENT_METHOD_DELETED: 'Deleted Payment Method',
  PAYMENT_METHOD_SET_AS_DEFAULT: 'Set Payment Method As Default',

  SCOUT_TOGGLED: 'scout:toggle',
  SCOUT_MESSAGE_SENT: 'scout:new-message',
  SCOUT_HISTORY_OPENED: 'scout:history-opened',
  SCOUT_CHAT_TITLE_UPDATED: 'scout:chat-title-updated',
  SCOUT_CHAT_OPENED_FROM_HISTORY: 'scout:chat-opened-from-history',
  SCOUT_SEARCH_USED: 'scout:history-search-used',
  SCOUT_THUMBS_UP: 'scout:thumbs-up',
  SCOUT_THUMBS_DOWN: 'scout:thumbs-down',
  SCOUT_GEOFENCE_CREATED: 'scout:geofence-created',

  PLACE_SUGGESTIONS_REVIEW_OPENED: 'Opened Geofence Suggestions Review',
  PLACE_SUGGESTIONS_BANNER_POSTPONED: 'Postponed Geofence Suggestions Banner',
  PLACE_SUGGESTION_GEOFENCE_CREATED: 'Created Geofence From Suggestion',
  PLACE_SUGGESTION_EDITOR_OPENED: 'Opened Geofence Suggestion In Editor',
  PLACE_SUGGESTION_DISMISSED: 'Dismissed Geofence Suggestion',

  FIND_CONTAINERS_OPENED: 'Opened Find Containers',
  CONTAINERS_SEARCHED: 'Searched Containers',
  CONTAINER_SITE_SELECTED: 'Selected Container Site',
  FIND_CONTAINERS_BASEMAP_TOGGLED: 'Toggled Find Containers Basemap',
  ADD_CONTAINER_TYPES_CLICKED: 'Clicked Add Container Types',

  TRACKER_POSITIONS_DOWNLOADED: 'Downloaded Tracker Positions',
  TRACKER_CURRENT_POSITIONS_DOWNLOADED: 'Downloaded Tracker Current Positions',
  TRACKERS_EXPORTED: 'Exported Selected Trackers',
  GROUP_POSITIONS_DOWNLOADED: 'Downloaded Group Positions',
  GROUP_CURRENT_POSITIONS_DOWNLOADED: 'Downloaded Group Current Positions',
  DEVICE_POINTS_DOWNLOADED: 'Downloaded Device Points',
  DEVICE_STOPS_DOWNLOADED: 'Downloaded Device Stops',
  GEOFENCE_LIST_DOWNLOADED: 'Downloaded Geofence List',
  GEOFENCE_REPORT_DOWNLOADED: 'Downloaded Geofence Report',
  REPORT_DOWNLOADED: 'Downloaded Report',
  REPORT_ADDRESSES_DOWNLOADED: 'Downloaded Report Addresses',
  REPORT_ALERTS_DOWNLOADED: 'Downloaded Report Alerts',
  SHIPMENT_POINTS_DOWNLOADED: 'Downloaded Shipment Points',
  SHIPMENT_EXCEPTIONS_EXPORTED: 'Exported Shipment Exceptions',
  SELECTED_SHIPMENT_EXCEPTIONS_EXPORTED:
    'Exported Selected Shipment Exceptions',
  SCOUT_FILE_DOWNLOADED: 'Downloaded Scout File',
  ORDER_INVOICE_DOWNLOADED: 'Downloaded Order Invoice',

  UI_ACTION_UPDATE_MAP: 'ui_update_map',
  UI_ACTION_FOCUS_GEOFENCE: 'ui_focus_geofence',
  UI_ACTION_ADD_POLYGON: 'ui_add_polygon',
  UI_ACTION_FILTER_DEVICES: 'ui_filter_devices',
  UI_ACTION_CREATE_FILE: 'ui_create_file',
  UI_ACTION_EXECUTE_COMMAND_UPDATE_ENTITIES: 'ui_revertable_bulk_update_entities',
  UI_ACTION_EXECUTE_COMMAND_APPEND_ENTITIES: 'ui_revertable_bulk_append_entities',
  UI_ACTION_EXECUTE_COMMAND: 'ui_execute_command',
  COMMAND_REVERTED: 'command_reverted',
};
